import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueResource from "vue-resource";
import VueJsonp from 'vue-jsonp';
import helpers from './components/helper/global';
import VueMatomo from 'vue-matomo';
import io from "socket.io-client"
// socket io
const socket = io(process.env.VUE_APP_SOCKET_IO_URL, {transports: ['websocket']})


Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueJsonp);

// Vue.use(VueMatomo, {
//   host: "https://control.searchinsights.de/",
//   siteId: process.env.VUE_APP_MATOMO_ID,
//   trackerFileName: 'matomo',
//   router: router,
//   enableLinkTracking: true,
//   requireConsent: false,
//   trackInitialView: true,
//   disableCookies: false,
//   enableHeartBeatTimer: false,
//   heartBeatTimerInterval: 15,
//   debug: false,
//   userId: undefined,
//   cookieDomain: undefined,
//   domains: undefined,
//   preInitActions: []
// });

Vue.use({
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
    // Vue.socket = socket;
    // Vue.prototype.$socket = socket;
  }
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
